import { render, staticRenderFns } from "./ShieldAlertIcon.vue?vue&type=template&id=093e05ea"
import script from "./ShieldAlertIcon.vue?vue&type=script&lang=js"
export * from "./ShieldAlertIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports